import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { TECProductVairantModal } from "@tecumseh/Services/TECProdunctVairant";
import { ProductVariantState } from "@tecumseh/Store/Data/TECProductVairantState";
// ProductVariantState

import { Draft } from "immer";

const initialState: ProductVariantState = {
    isLoading: false,
    value: undefined,
    parentProductId: "",
};

const reducer = {
    "Custom/ProductDetails/BeginProductVairant": (draft: Draft<ProductVariantState>) => {
        draft.isLoading = true;
    },
    "Custom/ProductDetails/CompltedProductVairant": (draft: Draft<ProductVariantState>, action: { result: TECProductVairantModal }) => {
        draft.isLoading = false;
        draft.value = action.result;
    },
    "Custom/ProductDetails/UpdateParentProductId": (
        draft: Draft<ProductVariantState>,
        action: { parentProductId: string },
    ) => {
        draft.parentProductId = action.parentProductId;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
